// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"746523a2","238":"c0bedfdd","771":"26d28453","997":"632980bd"}[chunkId] + ".chunk.css";
};